const IconBriefcase = ({ className }) => {
    return (
        <svg
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className={className}
        >
            <path
                d='M6 5.26317V3.15791C6 2.59956 6.21071 2.06407 6.58579 1.66926C6.96086 1.27445 7.46957 1.05264 8 1.05264H12C12.5304 1.05264 13.0391 1.27445 13.4142 1.66926C13.7893 2.06407 14 2.59956 14 3.15791V5.26317M10 10.5263V10.5369M1 11.579C3.79158 13.0597 6.87403 13.831 10 13.831C13.126 13.831 16.2084 13.0597 19 11.579M1 7.36843C1 6.81008 1.21071 6.2746 1.58579 5.87979C1.96086 5.48497 2.46957 5.26317 3 5.26317H17C17.5304 5.26317 18.0391 5.48497 18.4142 5.87979C18.7893 6.2746 19 6.81008 19 7.36843V16.8421C19 17.4005 18.7893 17.9359 18.4142 18.3308C18.0391 18.7256 17.5304 18.9474 17 18.9474H3C2.46957 18.9474 1.96086 18.7256 1.58579 18.3308C1.21071 17.9359 1 17.4005 1 16.8421V7.36843Z'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    );
};

export default IconBriefcase;
